"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketLink = void 0;
const core_1 = require("@apollo/client/core");
const graphql_1 = require("graphql");
const graphql_ws_1 = require("graphql-ws");
class WebSocketLink extends core_1.ApolloLink {
    constructor(options) {
        super();
        this.client = (0, graphql_ws_1.createClient)(options);
    }
    request(operation) {
        return new core_1.Observable((sink) => {
            return this.client.subscribe({ ...operation, query: (0, graphql_1.print)(operation.query) }, {
                next: sink.next.bind(sink),
                complete: sink.complete.bind(sink),
                error: sink.error.bind(sink),
            });
        });
    }
}
exports.WebSocketLink = WebSocketLink;
